<div class="dalloc" [class.disabled]="disabled">
  <div class="dalloc-head">
    <span class="dalloc-title">Split across {{ vm().length }} service{{ vm().length === 1 ? '' : 's' }}</span>
    <!-- Auto re-derives every row from cost share; Manual pins what is on screen and lets the
         reseller type. Typing in a single cell also flips the grid to Manual. -->
    <div class="dalloc-modes">
      <button type="button" class="dalloc-mode" [class.on]="mode() === 'auto'"
              [disabled]="disabled" (click)="setAuto()">Auto</button>
      <button type="button" class="dalloc-mode" [class.on]="mode() === 'manual'"
              [disabled]="disabled" (click)="setManual()">Manual</button>
    </div>
  </div>

  <div class="dalloc-row" *ngFor="let r of vm(); trackBy: trackByKey">
    <div class="dalloc-who">
      <div class="dalloc-dot" [style.background]="r.color + '22'">
        <app-cat-icon [code]="r.iconCode" [size]="13" [fill]="r.color"/>
      </div>
      <div class="dalloc-names">
        <div class="dalloc-name">{{ r.name }}</div>
        <div class="dalloc-vendor">{{ r.vendorName }}</div>
      </div>
    </div>
    <div class="dalloc-money">
      <div class="dalloc-inp">
        <span class="pfx">RM</span>
        <input type="number" inputmode="decimal" min="0" step="0.01" placeholder="0.00"
               [value]="displayAmount(r)" [disabled]="disabled"
               [attr.aria-label]="'Amount for ' + r.name"
               (input)="setAmount(r.key, $any($event.target).value)"
               (blur)="commitAmount(r.key)">
      </div>
      <!-- Auto only: the share is WHY the row got its figure. In manual the figure is whatever
           was typed, so the share explains nothing and reads as a second, competing percentage. -->
      <span class="dalloc-share" *ngIf="mode() === 'auto'">({{ r.shareLabel }} of package cost)</span>
    </div>
  </div>

  <div class="dalloc-foot" [class.bad]="unbalanced()">
    <span>Allocated <b>{{ allocated() | rm }}</b></span>
    <span class="dalloc-keep">you keep <b>{{ keep() | rm }}</b></span>
  </div>
  <div class="dalloc-warn" *ngIf="over()">⚠ Allocated more than this payment collects — take {{ -keep() | rm }} back off.</div>
  <div class="dalloc-warn" *ngIf="short()">⚠ {{ keep() | rm }} of this payment isn’t allocated. Every ringgit has to go to a service — keep adjusting until “you keep” reads RM 0.00.</div>
</div>
